(function () {
    console.log("video handler loaded")
    const banners = document.querySelectorAll(".videobanner");

    banners.forEach(b => {
        console.log("found a video")
        const video = b.querySelector("video");
        const playPauseBtn = b.querySelector(".bv-pause");

        if (video && playPauseBtn) {
            console.log("found a button")
            playPauseBtn.addEventListener("click", () => {
                handlePlayPause(video, playPauseBtn);
            });
        }
    });

    function handlePlayPause(video, playPauseBtn) {
        const pauseEl = playPauseBtn.getElementsByClassName("pause")[0];
        const playEl = playPauseBtn.getElementsByClassName("play")[0];

        if (pauseEl.classList.contains("show")) {
            hideElement(pauseEl)
            showElement(playEl)
            video.pause()
        } else {
            hideElement(playEl)
            showElement(pauseEl)
            video.play()
        }
    }

    function hideElement(el) {
        el.classList.remove("show")
        el.classList.add("hide")
    }

    function showElement(el) {
        el.classList.remove("hide")
        el.classList.add("show")
    }
})();